export const extractFileNameFromContentDisposition = (response: Response, fallback: string) => {
  const contentDisposition = response.headers.get('Content-Disposition')
  if (!contentDisposition) {
    return fallback
  }

  const matched = (contentDisposition.match(/filename="?([^";]+)"?/i)?.[1] || '').trim()

  return matched || fallback
}
